import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
}
export const Button: React.FC<ButtonProps> = ({
  children,
  className = '',
  ...props
}) => {
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`bg-gold hover:bg-gold-dark text-white font-sans font-bold py-3 px-5 md:py-4 md:px-8 rounded-none tracking-wide uppercase text-xs md:text-sm transition-colors duration-300 shadow-md ${className}`} {...props} data-id="element-8">
      {children}
    </motion.button>;
};